import { render, staticRenderFns } from "./ShortcutLinkItemComponent.vue?vue&type=template&id=86f8c93c&scoped=true"
import script from "./ShortcutLinkItemComponent.vue?vue&type=script&lang=js"
export * from "./ShortcutLinkItemComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f8c93c",
  null
  
)

export default component.exports